
import { Component, Prop, Vue } from 'vue-property-decorator';

import Icon from '@/components/UI/Icon.vue';
import LookupWarehouses from '@/components/UI/LookupWarehouses.vue';

import { fetchAddStairsService } from '@/helpers/fetchers';

import { JobComplianceData } from '@/models/JobComplianceTypes';

@Component({
  components: {
    Icon,
    LookupWarehouses,
  },
})
export default class AddStairsService extends Vue {
  @Prop({ type: Object, required: false, default: false }) public formData: JobComplianceData;

  public loading = false;
  public stairs_stop_number = 1;

  public stairsServiceRadioClicked(stop_number: number): void {
    this.stairs_stop_number = stop_number;
  }
  public addStairsClicked(stop_number: number): Promise<void> {
    this.loading = true;

    return fetchAddStairsService(this.formData.rockhopper_id, this.formData.rockhopper_date, stop_number)
      .then(res => {
        if (res === true) {
          this.$emit('fetchData', stop_number);
        }

        if (res === 'unlocked') {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          // const that = this;
          const that = () => {
            return this.addStairsClicked(stop_number);
          };

          this.$emit('fetchUnlockedJobAction', void this.addStairsClicked(stop_number), stop_number);
        }
      })
      .catch(() => void {})
      .finally(() => (this.loading = false));
  }
}
